import { memo } from "react";

export const CloseIcon = memo(() => (
  <svg viewBox="0 0 48 48" fill="none">
    <g clipPath="url(#clip0_5_2)">
      <g filter="url(#filter0_d_5_2)">
        <path
          d="M13.5 7L7 13.5L17.5 24L7 34.5L13.5 41L24 30.5L34.5 41L41 34.5L30.5 24L41 13.5L34.5 7L24 17.5L13.5 7Z"
          fill="#EA5A47"
        />
        <path
          d="M34.2246 6.58203C34.4187 6.45387 34.6827 6.47562 34.8535 6.64648L41.3535 13.1465C41.5488 13.3417 41.5488 13.6583 41.3535 13.8535L31.207 24L41.3535 34.1465C41.5488 34.3417 41.5488 34.6583 41.3535 34.8535L34.8535 41.3535C34.6583 41.5488 34.3417 41.5488 34.1465 41.3535L24 31.207L13.8535 41.3535C13.6583 41.5488 13.3417 41.5488 13.1465 41.3535L6.64648 34.8535C6.45122 34.6583 6.45122 34.3417 6.64648 34.1465L16.793 24L6.64648 13.8535C6.45122 13.6583 6.45122 13.3417 6.64648 13.1465L13.1465 6.64648L13.2246 6.58203C13.4187 6.45387 13.6827 6.47562 13.8535 6.64648L24 16.793L34.1465 6.64648L34.2246 6.58203Z"
          stroke="black"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5_2"
        x="2"
        y="6"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5_2"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5_2"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_5_2">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
